import { useMsal } from "@azure/msal-react";

/**
 * Hook to check if the current user has the CustomerManager role.
 * CustomerManager role allows managing groups and viewing program progress for their own organization.
 */
export function useIsCustomerManager(): boolean {
    const { accounts } = useMsal();
    const account = accounts[0];

    if (!account?.idTokenClaims) return false;

    // Read roles directly from ID token (same as AcademyManager approach)
    const roles = (account.idTokenClaims?.roles as string[] | undefined) || [];
    const hasRole = roles.includes("CustomerManager");

    return hasRole;
}
